var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"scroll-content",style:({ top: _vm.top, transition: _vm.transition })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }